import { redirectTo } from '../services/history-service';
import { COMMON_PAGE_PATHS } from '../../constans/url-constants';
import { DEFAULT_CSV_FILE_NAME } from '../../constans/common-constants';

export type TPresenterLinkPathHook = {
  urlPath: string;
  envPath: string;
  urlHash: string;
  appUri?: string;
}

export const searchQueryCompiler = (params: {[key: string]: string}): string => {
  const mappedParams:string = Object.keys(params).map(value => `${value}=${params[value]}`).join('&');
  return `?${mappedParams}`;
};

export const getPresenterLinkPath = (): TPresenterLinkPathHook => {
  const urlPath = window.location.pathname;
  const urlHash = window.location.hash;
  const envPath = `${process.env.REACT_APP_URI}${urlPath}`;
  const appUri = process.env.REACT_APP_URI;

  return {
    urlPath,
    envPath,
    urlHash,
    appUri
  };
};

export const extractPathIdentifier = (identifier: string): string => {
  const { urlPath, appUri } = getPresenterLinkPath();
  const splitPathname = urlPath.split('/');
  const indexValue = 1;
  const identifierIndex = splitPathname.indexOf(identifier);
  if (identifierIndex < 0) redirectTo(`${appUri}/${COMMON_PAGE_PATHS.NOT_FOUND}`);
  return splitPathname[identifierIndex+indexValue];
};


export const getContentDispositionFileName = (contentDisposition: string): string => {
  const indexOfValue = -1;
  if (contentDisposition.indexOf('attachment') !== indexOfValue) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      const removeEncoding = matches[1].replace('UTF-8', '');
      return decodeURIComponent(removeEncoding.replace(/['"]/g, ''));
    }
  }
  return DEFAULT_CSV_FILE_NAME;
};
